import { InputAdornment, TextField } from "@material-ui/core";
import { inventoryDictionary } from "helpers/dictionary";
import { patternDecimal } from "helpers/getNumberFormats";
import { useRuleValidator } from "hooks/useRuleValidator";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePercentageInventory } from "redux/actions/inventories/inventoriesAction";
import { PERMISSIONS } from "router/permissions";

export const UpdatePercentageComponent = ({
  keyInventory = "storagesInventory",
  data,
  fullWidth = false,
}) => {
  const dispatch = useDispatch();
  const { inventory } = useSelector(({ inventories }) => inventories);
  const status = inventory?.status;
  const isRule = useRuleValidator(PERMISSIONS.INVENTORIES_CONTROL_EDIT);

  const isNegativeInventory = inventory?.config?.allowsNegativeInventory;
  const handlePercentage = ({ target }, _v) => {
    const rawValue = target.value.replace(",", ".");

    const regex = isNegativeInventory ? /^-?\d*[.,]?\d*$/ : /^\d*[.,]?\d*$/;
    if (rawValue !== "" && !regex.test(rawValue)) return;

    // Dispatch the raw value if it matches the regex but isn't a complete number yet
    // or if it's a valid number that needs clamping.
    const numericValue = parseFloat(rawValue);

    if (
      rawValue === "" ||
      rawValue === "-" ||
      rawValue === "." ||
      rawValue === "-." ||
      isNaN(numericValue)
    ) {
      dispatch(
        updatePercentageInventory(
          keyInventory,
          inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
          rawValue === "" ? 0 : rawValue,
        ),
      );
      return;
    }

      if (numericValue > 100) {
        dispatch(
          updatePercentageInventory(
            keyInventory,
            inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
            100,
          ),
        );
      } else if (isNegativeInventory && numericValue < -100) {
        dispatch(
          updatePercentageInventory(
            keyInventory,
            inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
            -100,
          ),
        );
      } else if (!isNegativeInventory && numericValue < 0) {
        dispatch(
          updatePercentageInventory(
            keyInventory,
            inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
            0,
          ),
        );
      } else {
        // Despachar el valor original (string) para preservar puntos decimales o ceros iniciales
        dispatch(
          updatePercentageInventory(
            keyInventory,
            inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
            rawValue,
          ),
        );
    }
  };

  return (
    <TextField
      value={data.currentPercentage ?? ""}
      name="currentPercentage"
      type="text"
      onChange={(e) => handlePercentage(e)}
      onFocus={(e) => {
        if (parseFloat(e.target.value) === 0) {
          dispatch(
            updatePercentageInventory(
              keyInventory,
              inventoryDictionary.local === keyInventory ? data.idTank : data.idUnit,
              ""
            )
          );
        }
      }}
      align="center"
      InputProps={{
        endAdornment: <InputAdornment position="end">%</InputAdornment>,
        inputProps: {
          style: { textAlign: "center" },
          min: isNegativeInventory ? -100 : 0,
          max: 100,
          step: 0.1,
          inputMode: "decimal",
        },
      }}
      disabled={status === "CLOSED" || !isRule}
      fullWidth={fullWidth}
    />
  );
};
